import axios from 'axios'
import {actionTypes} from '@/commons/constants'
import { AzSearchUrlBuilder } from '@azinformatica/loki'

export default {
    async [actionTypes.NOTIFICACOES.BUSCAR_NOTIFICACOES]({state}, filters) {
        const {paginacao} = state.notificacoesBusca
        const url = AzSearchUrlBuilder.build('api/notificacoes', filters, paginacao)
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.NOTIFICACOES.LER_NOTIFICACOES](_, notificacaoIdList) {
        return await axios.put(`api/notificacoes/lido`, notificacaoIdList)
    },

    async [actionTypes.NOTIFICACOES.LER_TODAS_NOTIFICACOES](_) {
        return await axios.put(`api/notificacoes/lido/todas`)
    },

    async [actionTypes.NOTIFICACOES.REMOVER_NOTIFICACAO](_, notificacaoId) {
        return await axios.delete(`api/notificacoes/${notificacaoId}`)
    },
}